export default __webpack_public_path__ + "static/media/gl_4.a1383288.mp3";